// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarItem-module--root--2oQ-C","link":"NavbarItem-module--link--1jLu6","counter":"NavbarItem-module--counter--3_QtE"};